import state from './moduleVesselMonitoringEngineState.js'
import mutations from './moduleVesselMonitoringEngineMutations.js'
import actions from './moduleVesselMonitoringEngineActions.js'
import getters from './moduleVesselMonitoringEngineGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}